/* components/patterns/MobileTabBar.jsx — нижний таб-бар (xs) + «Ещё»-шторка.
   Таб-бар (02-IA §3.5): Ассистент·Кухня·Аналитика·Отчёты·Ещё. Шторка «Ещё»:
   Уведомления · Аккаунт · переключатель пространства · Выйти.
   («Найти»/палитра убрана — диалоги открываются иконкой чатов в шапке Ассистента.)
   Тач-цели ≥44px, не перекрывается тостами. Источник: 02-IA §3.5, §4. */

import React from 'react';
import ReactDOM from 'react-dom';
import { navConfig } from '../../app/navConfig.js';
import { useAuth } from '../../app/providers/AuthProvider.jsx';
import { useToast } from '../../app/providers/ToastProvider.jsx';
import { Icon } from '../ui/Icon.jsx';
import { getOverlayRoot } from '../../lib/overlay.jsx';
import { workspaceName } from '../../lib/workspace.js';
import { RR } from '../../lib/router.jsx';

  // isNavItemVisible — то же правило, что и в сайдбаре (navConfig.js). Шторка знала
  // только про consoleOnly, поэтому «Обучение» висело в «Ещё» и при выключенном
  // ACADEMY_ENABLED вело на экран «раздел отключён» (PL-7).
  // Тот же принцип для тарифных рубильников пространства (workspace.sections): вкладки
  // таб-бара берём через mobileTabsFor(user, workspace), а не сырым MOBILE_TABS — иначе
  // «Аналитика» остаётся внизу экрана у пространства, где тариф её выключил.
  const { MORE_SHEET, isNavItemVisible, mobileTabsFor } = navConfig;
  const { NavLink, useNavigate } = RR;
  const { useState } = React;

  function MoreSheet({ open, onClose }) {
    const auth = useAuth ? useAuth() : null;
    const toast = useToast ? useToast() : null;
    const navigate = useNavigate();
    if (!open) return null;
    // переключатель пространства (02-IA §3.5) — показываем при >1 пространстве
    const workspaces = (auth && auth.workspaces) || [];
    const activeWorkspace = auth && auth.activeWorkspace;
    const multiWs = workspaces.length > 1;
    const switchTo = (ws) => {
      onClose();
      if (ws && activeWorkspace && ws.id !== activeWorkspace.id && auth.switchWorkspace) auth.switchWorkspace(ws.id);
    };
    const doLogout = () => {
      onClose();
      if (auth && auth.logout) auth.logout();
      if (toast && toast.show) toast.show('Вы вышли из аккаунта', 'muted');
      navigate('/signin');
    };
    return ReactDOM.createPortal(
      <div className="overlay" style={{ zIndex: 'var(--z-modal)', alignItems: 'flex-end' }}>
        <div className="overlay__backdrop" onClick={onClose} />
        <div className="sheet" role="dialog" aria-label="Ещё">
          <div className="sheet__grip" />
          <div className="sheet__title t-h4">Ещё</div>
          <nav className="stack stack-2">
            {MORE_SHEET.filter((item) => isNavItemVisible(item, auth?.user, activeWorkspace)).map((item) => (
              <NavLink key={item.id} to={item.to} onClick={onClose}
                className={({ isActive }) => 'sheet__item' + (isActive ? ' is-active' : '')}>
                <Icon name={item.icon} size={20} />
                <span className="grow">{item.label}</span>
                <Icon name="chevron-right" size={16} className="text-mute" />
              </NavLink>
            ))}
          </nav>

          {multiWs && (
            <>
              <div className="popover__sep" />
              <div className="sheet__title t-eyebrow text-mute">Пространство</div>
              <nav className="stack stack-2">
                {workspaces.map((ws) => {
                  const isActive = !!activeWorkspace && ws.id === activeWorkspace.id;
                  return (
                    <button key={ws.id} type="button"
                      className={'sheet__item' + (isActive ? ' is-active' : '')}
                      onClick={() => switchTo(ws)} disabled={isActive}>
                      {ws.kind === 'business'
                        ? <Icon name="restaurant" size={20} />
                        : <img src="/logo-mark.svg" alt="" width={20} height={20} />}
                      <span className="grow truncate">{workspaceName(ws)}</span>
                      {isActive && <Icon name="check" size={16} className="text-accent" />}
                    </button>
                  );
                })}
              </nav>
            </>
          )}

          <div className="popover__sep" />
          <button type="button" className="sheet__item" onClick={doLogout}>
            <Icon name="logout" size={20} />
            <span className="grow">Выйти</span>
          </button>
        </div>
      </div>,
      getOverlayRoot()
    );
  }

  function MobileTabBar() {
    const [moreOpen, setMoreOpen] = useState(false);
    const auth = useAuth ? useAuth() : null;
    const tabs = mobileTabsFor(auth && auth.user, auth && auth.activeWorkspace);
    return (
      <>
        <nav className="tab-bar" aria-label="Навигация">
          {tabs.map((item) => {
            if (item.id === 'more') {
              return (
                <button key="more" className={'tab-bar__item' + (moreOpen ? ' is-active' : '')}
                  onClick={() => setMoreOpen(true)}>
                  <Icon name={item.icon} size={22} />
                  <span className="tab-bar__label">{item.label}</span>
                </button>
              );
            }
            return (
              <NavLink key={item.id} to={item.to} data-onb={'nav-' + item.id}
                className={({ isActive }) => 'tab-bar__item' + (isActive ? ' is-active' : '')}>
                <Icon name={item.icon} size={22} />
                <span className="tab-bar__label">{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <MoreSheet open={moreOpen} onClose={() => setMoreOpen(false)} />
      </>
    );
  }

export { MobileTabBar };
